// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ViewUI from 'view-design'
import Http from './libs/http'
import 'view-design/dist/styles/iview.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueResource from 'vue-resource'
import wx from 'weixin-js-sdk'
import VueAMap from 'vue-amap'
/* import VueTouch from 'vue-touch';

Vue.use(VueTouch, {name: 'v-touch'}); */
import vuescroll from 'vuescroll'
import 'vuescroll/dist/vuescroll.css'
Vue.use(vuescroll)
Vue.config.productionTip = false
Vue.use(ViewUI)
Vue.use(Http)
Vue.use(VueResource)
Vue.use(ElementUI)
Vue.use(wx)
Vue.use(VueAMap)
// 测试APPID
Vue.prototype.APPID = 'wxd1980a921f253154'
// 线上APPID
// Vue.prototype.APPID = 'wxa2b66cf6a6a8ad2e';
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
  // components: { App },
  // template: '<App/>'
})
window._AMapSecurityConfig = {
  securityJsCode: '1faf6bf430facdfe5ae1e8009f86ab7c'
}
VueAMap.initAMapApiLoader({
  key: '4ab11b2abc3cebc581caa1cfdffb7d37',
  plugin: ['AMap.DistrictSearch', 'AMap.Geolocation'],
  v: '1.4.4'
})



// WEBPACK FOOTER //
// ./src/main.js